import { useEffect } from "react";
import { BRAND, DOMAIN } from "@/data/site";

const SITE_URL = `https://${DOMAIN}`;
const DEFAULT_TITLE = `${BRAND} — Experiências memoráveis nos melhores resorts do Brasil`;
const DEFAULT_DESCRIPTION =
    "Destino Resorts — curadoria independente dos melhores resorts do Brasil. Compare destinos e receba cotação personalizada direto no seu WhatsApp.";

const setMeta = (attr, key, content) => {
    if (!content) return;
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
};

const setCanonical = (href) => {
    let el = document.head.querySelector('link[rel="canonical"]');
    if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", "canonical");
        document.head.appendChild(el);
    }
    el.setAttribute("href", href);
};

/**
 * SEO dinâmico por página: título, description, Open Graph e Twitter Card.
 * Todo resort cadastrado em src/data/resorts.js ganha SEO próprio automaticamente.
 */
export function useSEO({ title, description, image, path = "/", type = "website" }) {
    useEffect(() => {
        const fullTitle = title ? `${title} | ${BRAND}` : DEFAULT_TITLE;
        const desc = description || DEFAULT_DESCRIPTION;
        const url = `${SITE_URL}${path}`;

        document.title = fullTitle;
        setMeta("name", "description", desc);
        setMeta("property", "og:title", fullTitle);
        setMeta("property", "og:description", desc);
        setMeta("property", "og:url", url);
        setMeta("property", "og:type", type);
        setMeta("property", "og:site_name", BRAND);
        setMeta("property", "og:locale", "pt_BR");
        if (image) {
            setMeta("property", "og:image", image);
            setMeta("name", "twitter:card", "summary_large_image");
            setMeta("name", "twitter:image", image);
        }
        setMeta("name", "twitter:title", fullTitle);
        setMeta("name", "twitter:description", desc);
        setCanonical(url);
    }, [title, description, image, path, type]);
}
